import { toast } from 'react-toastify';

export const notifyError = (message) => {
  toast.error(message || 'Something went wrong', {
    position: 'top-right',
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const notifySuccess = (message) => {
  toast.success(message || 'Success', {
    position: 'top-right',
    autoClose: 4000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};
